<template>
    <article class="reset-password">
        <section>
            <h2>{{ resetPassTitle }}</h2>
            <div class="subtitle">{{ resetPassTagline }}</div>
        </section>
        <section>
            <ns-toast
                success
                icon
                :delay="delay"
                :show-trigger="showTrigger"
                :message="toastMessage"
            />
            <ns-toast
                error
                :delay="delay"
                :persistent="persist"
                :show-trigger="showTriggerError"
                :message="resetFormErrorMsg"
            />
            <v-form
                ref="resetPasswordForm"
                label="createPassInputLabel"
                v-model="resetPasswordForm"
                @submit.prevent
            >
                <ns-okta-password
                    v-model="newPassword"
                    :translations="translations"
                    @passwordUpdated="passwordUpdated"
                    @valid="newPasswordValid = $event"
                />
                <button
                    flat
                    block
                    class="primary-hit mb-2 fluid"
                    :disabled="!resetPasswordForm || !passwordFormValid"
                    @mousedown="handleResetPassword"
                >
                    {{ resetPassBtnText }}
                </button>
            </v-form>
        </section>
    </article>
</template>

<script>
import {AuthenticationService} from '@nuskin/ns-account';
import {NsOktaPassword, NsToast} from '@nuskin/design-components';
import {events} from '@nuskin/ns-util';

// const loginPageConfig = {};
// loginPageConfig.pwrt = '';

export default {
    name: 'ResetPassword',
    components: {
        NsOktaPassword,
        NsToast
    },
    props: {
    /**
     * The label text for the password expired text label 3
     */
        passExpirationLabel_3: {
            type: String,
            default: 'Your password reset link has expired.'
        },
        /**
     * The label text for the forgot password input on the forgot password view
     */
        forgotPassLabel: {
            type: String,
            default: 'Username (Email Address)'
        },
        /**
     * The error message that gets displayed when the reset password fails
     */
        resetFormErrorMsg: {
            type: String,
            default: 'There was an error reseting your password please try again.'
        },
        /**
     * The text displayed on the button in the reset password view
     */
        resetPassBtnText: {
            type: String,
            default: 'Continue'
        },
        /**
     * Message that appears in the toast message after a successful password reset
     */
        resetFormSuccessMsg: {
            type: String,
            default: 'Success! New password created.'
        },
        /**
     * Deprecated?
     */
        resetPassInputError: {
            type: String,
            default: 'Your password is required'
        },
        /**
     * The sub text for the reset password view (just under the title)
     */
        resetPassTagline: {
            type: String,
            default:
        'Cool, now go ahead and make a new password. Don\'t use a previous password or we\'re going to have trouble. Big trouble.'
        },
        /**
     * The title text for the reset password view
     */
        resetPassTitle: {
            type: String,
            default: 'Reset Password'
        },
        /**
     * Heading for the password requirements section
     */
        passRequirementsMsg: {
            type: String,
            default:
        'Password must be at least 8 characters and meet three of the four requirements below:'
        },
        /**
     * Text for the password lowercase requirement
     */
        passRuleLowercaseText: {
            type: String,
            default: 'Password contains a lowercase letter'
        },
        /**
     * Text for the password lowercase requirement
     */
        passRuleNumberText: {
            type: String,
            default: 'Password contains a number'
        },
        /**
     * Text for the password lowercase requirement
     */
        passRuleSpecialCharText: {
            type: String,
            default: 'Password contains a special character'
        },
        /**
     * Text for the password lowercase requirement
     */
        passRuleUppercaseText: {
            type: String,
            default: 'Password contains an uppercase letter'
        },
        createPassInputLabel: {
            type: String,
            default: 'Create Password'
        },
        passwordShowText: {
            type: String,
            default: 'Show'
        },
        passwordHideText: {
            type: String,
            default: 'Hide'
        }
    },
    data() {
        return {
            newPassword: '',
            newPasswordValid: false,
            resetPasswordForm: 'false',
            dialog: true,
            dialogError: null,
            emailAddress: '',
            emailAddressForm: {},
            showTrigger: false,
            toastMessage: 'Error',
            showTriggerError: false,
            delay: 50,
            toastMessageError: 'Error',
            persist: true,
            translations: {
                changePassword: 'Change Password',
                newPassword: 'New Password',
                passwordRequired: 'Password is required',
                includes8Chars: 'Use 8 or more characters',
                includesUpper: 'Use an upper case letter (e.g. A)',
                includesLower: 'Use a lower case letter (e.g. a)',
                includesNumber: 'Use a number (e.g. 1234)',
                includesSpecialChars: 'Use a symbol (e.g. !@#$)',
                criteriaComplete: 'Your Password is STRONG',
                validationRequirement: 'All Conditions must be met',
                passwordConditionsMet: 'Password doesn\'t meet minimum requirements',
                hide: 'HIDE',
                show: 'SHOW'
            }
        };
    },
    computed: {
        passwordFormValid() {
            return this.newPassword && this.newPasswordValid;
        }
    },
    methods: {
        handleResetPassword(e) {
            this.resetPasswordForm = false;
            if (this.$features['cx107-account-util-proxy-cutover'] || this.$features['cx107-account-util-proxy-pilot-run']) {
                AuthenticationService.resetPasswordAccountUtilProxy(
                    window.loginPageConfig.pwrt,
                    this.newPassword
                );
            } else {
                AuthenticationService.resetPassword(
                    window.loginPageConfig.pwrt,
                    this.newPassword
                );
            }
        },
        passwordUpdated(e) {
            this.password = e;
        },
        _handleResetError() {
            this.resetPasswordForm = true;
            this.showTriggerError = !this.showTriggerError;
        },
        _handleResetSuccess() {
            this.resetPasswordForm = true;
            window.location = window.location.pathname + '?showResetSuccess=true';
        },
        _setTranslations() {
            const loginTranslations = window.loginTranslations;
            this.createPassInputLabel =
        loginTranslations.createPassInputLabel || this.createPassInputLabel;
            this.resetFormErrorMsg =
        loginTranslations.resetFormErrorMsg || this.resetFormErrorMsg;
            this.resetPassBtnText =
        loginTranslations.resetPassBtnText || this.resetPassBtnText;
            this.resetPassInputError =
        loginTranslations.resetPassInputError || this.resetPassInputError;
            this.resetPassTagline =
        loginTranslations.resetPassTagline || this.resetPassTagline;
            this.resetPassTitle =
        loginTranslations.resetPassTitle || this.resetPassTitle;
            this.resetFormSuccessMsg =
        loginTranslations.resetFormSuccessMsg || this.resetFormSuccessMsg;

            this.passRequirementsMsg =
        loginTranslations.passRequirementsMsg || this.passRequirementsMsg;
            this.translations.passRuleLowercaseText =
        loginTranslations.passRuleLowercaseText || this.passRuleLowercaseText;
            this.passRuleNumberText =
        loginTranslations.passRuleNumberText || this.passRuleNumberText;
            this.passRuleSpecialCharText =
        loginTranslations.passRuleSpecialCharText ||
        this.passRuleSpecialCharText;
            this.passRuleUppercaseText =
        loginTranslations.passRuleUppercaseText || this.passRuleUppercaseText;
            this.passwordShowText =
        loginTranslations.passwordShowText || this.passwordShowText;
            this.passwordHideText =
        loginTranslations.passwordHideText || this.passwordHideText;

            this.translations.newPassword =
        loginTranslations.createPassInputLabel || this.createPassInputLabel;
            this.translations.show =
        loginTranslations.passwordShowText || this.passwordShowText;
            this.translations.hide =
        loginTranslations.passwordHideText || this.passwordHideText;

            this.translations.passwordRequired =
        loginTranslations.resetPassInputError || this.resetPassInputError;
            this.translations.includes8Chars =
        loginTranslations.createPassInputLabel || this.createPassInputLabel;
            this.translations.includesUpper =
        loginTranslations.passRuleUppercaseText || this.passRuleUppercaseText;
            this.translations.includesLower =
        loginTranslations.passRuleLowercaseText || this.passRuleLowercaseText;
            this.translations.includesNumber =
        loginTranslations.passRuleNumberText || this.passRuleNumberText;
            this.translations.includesSpecialChars =
        loginTranslations.passRuleSpecialCharText ||
        this.passRuleSpecialCharText;
            this.translations.criteriaComplete =
        loginTranslations.createPassInputLabel || this.createPassInputLabel;
            this.translations.validationRequirement =
        loginTranslations.createPassInputLabel || this.createPassInputLabel;
            this.translations.passwordConditionsMet =
        loginTranslations.passRequirementsMsg || this.passRequirementsMsg;
            this.passExpirationLabel_3 =
        loginTranslations.passExpirationLabel_3 || this.passExpirationLabel_3;
        }
    },
    mounted() {
        this._setTranslations();
        events.subscribe(events.authentication.RESET_PASSWORD_ERROR, (message) => {
            this._handleResetError();
        });
        events.subscribe(
            events.authentication.RESET_PASSWORD_SUCCESS,
            (message) => {
                this._handleResetSuccess();
            }
        );
    }
};
</script>

<style lang="scss">

@media (min-width: 768px){
    .reset-password section {
        max-width: 400px;
        margin: 50px auto 30px auto;
    }
}
</style>
